import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Download, ArrowLeft, FileText, Building2, 
  Bot, ShoppingCart, TrendingUp, Users
} from 'lucide-react';
import { Button } from '../components/ui/button';

const DeckPage = () => {
  const deckUrl = '/deck/LunchRoll_PitchDeck_2026.pdf';
  
  const slides = [
    { num: 1, title: 'Cover', desc: 'Lunch & Roll - Alimentación Inteligente para Oficinas' },
    { num: 2, title: 'Problema', desc: 'El problema de alimentación en oficinas mexicanas' },
    { num: 3, title: 'Solución', desc: 'Plataforma todo-en-uno para alimentación corporativa' },
    { num: 4, title: 'Producto', desc: '92 productos, 14 categorías, 6 roles, 8 AI Agents' },
    { num: 5, title: 'Para Empresas', desc: 'Control total de alimentación del equipo' },
    { num: 6, title: 'AI Agents', desc: '8 agentes de IA para automatización' },
    { num: 7, title: 'Menú', desc: 'Catálogo de productos saludables' },
    { num: 8, title: 'Modelo de Negocio', desc: 'SaaS B2B + Comisión + Suscripciones' },
    { num: 9, title: 'Mercado', desc: 'TAM $8.5B - SAM $850M - SOM $85M' },
    { num: 10, title: 'Tracción', desc: '$16,725 revenue, 50 órdenes, 5 empresas' },
    { num: 11, title: 'Roadmap', desc: 'Plan 2026-2027' },
    { num: 12, title: 'La Oportunidad', desc: 'Ronda Seed $500K USD' },
    { num: 13, title: 'Contacto', desc: 'contacto@lunchroll.com' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-emerald-800 to-stone-900">
      {/* Header */}
      <header className="p-6">
        <Link to="/" className="inline-flex items-center gap-2 text-emerald-300 hover:text-white transition-colors">
          <ArrowLeft className="w-5 h-5" />
          Volver al inicio
        </Link>
      </header>

      {/* Hero */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 text-emerald-300 px-4 py-2 rounded-full text-sm mb-6">
            <FileText className="w-4 h-4" />
            Pitch Deck 2026
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Lunch & Roll
          </h1>
          <p className="text-xl text-emerald-200 mb-8">
            Alimentación Inteligente para Oficinas
          </p>
          
          <a 
            href={deckUrl} 
            download="LunchRoll_PitchDeck_2026.pdf"
            className="inline-flex items-center gap-3 bg-white text-emerald-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-all shadow-lg hover:shadow-xl hover:scale-105"
          >
            <Download className="w-6 h-6" />
            Descargar Deck (PDF)
          </a>
          
          <p className="text-emerald-400 text-sm mt-4">
            13 slides • 20 KB • Actualizado Abril 2026
          </p>
        </div>

        {/* Key Metrics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {[
            { icon: Building2, value: '5', label: 'Empresas' },
            { icon: Users, value: '10', label: 'Usuarios' },
            { icon: ShoppingCart, value: '92', label: 'Productos' },
            { icon: Bot, value: '8', label: 'AI Agents' },
          ].map((stat, i) => (
            <div key={i} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/10">
              <stat.icon className="w-8 h-8 text-emerald-400 mx-auto mb-3" />
              <p className="text-3xl font-bold text-white">{stat.value}</p>
              <p className="text-emerald-300 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Slides Preview */}
        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
          <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
            <FileText className="w-6 h-6 text-emerald-400" />
            Contenido del Deck
          </h2>
          
          <div className="grid md:grid-cols-2 gap-3">
            {slides.map((slide) => (
              <div 
                key={slide.num}
                className="flex items-center gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors"
              >
                <div className="w-10 h-10 bg-emerald-500 rounded-lg flex items-center justify-center text-white font-bold">
                  {slide.num}
                </div>
                <div>
                  <h3 className="font-semibold text-white">{slide.title}</h3>
                  <p className="text-emerald-300 text-sm">{slide.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-emerald-300 mb-4">
            ¿Interesado en invertir o colaborar?
          </p>
          <a 
            href="mailto:contacto@lunchroll.com"
            className="inline-flex items-center gap-2 text-white hover:text-emerald-300 transition-colors"
          >
            contacto@lunchroll.com
            <TrendingUp className="w-4 h-4" />
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="text-center py-8 text-emerald-400 text-sm">
        © 2026 Lunch & Roll - Confidencial
      </footer>
    </div>
  );
};

export default DeckPage;
